import { render, staticRenderFns } from "./ModifyRepaymentPlanPackageModal.vue?vue&type=template&id=4987d770&"
import script from "./ModifyRepaymentPlanPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyRepaymentPlanPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports